export enum CouponFrequency {
  ONCE = "ONCE",
  MONTHLY = "MONTHLY",
  FOREVER = "FOREVER",
}
